import React from "react";

//types
import ProductType, {
    ClientProductTypes,
    ClientProductTypesList
} from "../../../common/interfaces/enums/ProductType";

// components
import ProductNavigationButtonV2 from "../ProductNavigationButtonV2/ProductNavigationButtonV2";
import Icon from "../../../common/components/Icon/Icon";

//styles
import cx from "classnames";
import PromoteDAP from "../../../digital-advice/components/PromoteDAP/PromoteDAP";

interface IProductNavigationV2Props {
    selectedProducts: ProductType[];
    setSelectedProducts: React.ComponentProps<
        typeof ProductNavigationButtonV2
    >["setSelectedProducts"];
}

const ProductNavigationV2: React.FC<IProductNavigationV2Props> = (props) => {
    const { selectedProducts, setSelectedProducts } = props;

    const productsTooltipText: {
        [key in ClientProductTypes]: string;
    } = {
        [ProductType.Life]:
            "Have a lump sum paid out for your loved ones if the unexpected happens to you.",
        [ProductType.Trauma]:
            "Have a lump sum paid out for your loved ones if the unexpected happens to you.",
        [ProductType.Health]:
            "Get treatment faster. Skip the public waiting list and get back on your feet in no time.",
        [ProductType.Mortgage]:
            "Protect your mortgage payments in the event you're ill or injured and are not able to work.",
        [ProductType.Income]:
            "Protect your income if an unexpected illness stops you from being able to work."
    };

    return (
        <div className={cx("layout-flex-row--justify-centered")}>
                <div className={cx("layout-multi-products-navigation-V2")}>
                    <div className={cx("layout-flex-row--justify-centered", "gap-3xl")}>
                        <Icon className="space-l" id="BundleDiscount" />
                        <span>
                            Some insurers offer discounts when you bundle your insurance
                        </span>
                    </div>
                <div className={cx("gap-2xl")}>
                    {ClientProductTypesList.map((product, index) => (
                        <ProductNavigationButtonV2
                            productType={product}
                            setSelectedProducts={setSelectedProducts}
                            selectedProducts={selectedProducts}
                            key={index}
                            tooltipContent={productsTooltipText[product]}
                        />
                    ))}
                </div>
                <PromoteDAP isDapActive={false} className={cx("space-pre-m", "layout-flex-row--justify-centered")} />
            </div>
        </div>
    );
};

export default ProductNavigationV2;
